<template>
  <div>
    <DeleteModal
      modal-id="modal-surgery-insurance-delete"
      @deleteToggle="deleteItem"
    />

    <b-modal
      id="modal-surgery-insurance-edit"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('surgery.Add Patient Surgery Insurance Invoices')
          : $t('surgery.Edit Patient Surgery Insurance Invoices')
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="4">
            <AutoComplete
              v-model="surgeryId"
              :label="$t('surgery.surgery')"
              :placeholder="$t('surgery.surgery')"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="surgery"
              text-title="title"
            />
          </b-col>
          <b-col
            v-if="surgeryId"
            lg="4"
          >
            <AutoComplete
              v-if="surgeryId && createMode !== 'create'"
              v-model="EditForm.doctor_id"
              :label="$t('surgery.Doctors-Surgery')"
              :placeholder="$t('surgery.Doctors-Surgery')"
              param-query="search"
              :serializer="(val) => val.doctor_id"
              endpoint="doctorSurgery"
              text-title="doctor_name"
              alt-search="doctor.name"
              :other-query="`filter[surgery_id]=${surgeryId}`"
            />
          </b-col>

          <b-col lg="4">
            <b-form-group
              :label="$t('surgery.Surgery Insurance Amount')"
              label-for="Amount"
            >
              <b-form-input
                id="Amount"
                v-model="EditForm.amount"
                type="number"
                :placeholder="$t('surgery.Surgery Insurance Amount')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card>
      <!-- Search Patient Name -->
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t('surgery.Patient Surgery Insurance Invoices') }}</h2>
          <b-button
            v-if="
              !isHistory
            "
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t('surgery.Add Patient Surgery Insurance Invoices') }}
          </b-button>
        </div>

        <b-table
          v-if="!loading"
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
        >
          <template #cell(amount)="data">
            <span class="text-nowrap"> {{ data.item.amount }} IQD </span>
          </template>

          <template #cell(status)="data">
            <div class="text-nowrap">
              <b-badge
                pill
                size="sm"
                :variant="badgeVariant(data.item.status)"
                class="custom-badge"
              >
                <b-dropdown
                  size="sm"
                  :text="data.item.status"
                  variant="text"
                  no-flip
                  class="custom-dropdown text-light"
                >
                  <template #button-content>
                    <span class="dropdown-text">{{ data.item.status }}</span>
                  </template>
                  <b-dropdown-item
                    class="dropdown-item-text"
                    @click="showChangeStatusModal('pending', data.item.id)"
                  >
                    Pending
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item-text"
                    @click="showChangeStatusModal('approved', data.item.id)"
                  >
                    Approved
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="$store.state.app.permissions.includes('show-rejected')"
                    class="dropdown-item-text"
                    @click="showChangeStatusModal('rejected', data.item.id)"
                  >
                    Rejected
                  </b-dropdown-item>
                </b-dropdown>
              </b-badge>
              <ChangeInvoiceStatus
                :inovice-id="InvoiceId"
                :invoicestatus="invoiceLatestStatus"
                @onChange="getPatientsSurgeries"
              />
            </div>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <b-button
                v-if="
                  $store.state.app.permissions.includes(
                    'update-invoiceInsuranceSurgery'
                  ) && !isHistory
                "
                size="sm"
                pill
                variant="outline-secondary"
                class="mb-75 mx-1"
                @click="$bvModal.show('modal-edit-invoice-status')"
              >
                {{ $t('common.edit-status') }}
              </b-button>

              <ActionsButtons
                v-if="!isHistory"
                delete-perm="update-invoiceInsuranceSurgery"
                edit-perm="update-invoiceInsuranceSurgery"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span
                class="text-muted"
              >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="index()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BBadge,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Datepicker from 'vuejs-datepicker'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import DeleteModal from '@/components/modals/DeleteModal.vue'
import ChangeInvoiceStatus from '@/components/modals/ChangeInvoiceStatus.vue'
import ActionsButtons from '@/components/common/ActionsButtons.vue'

const AutoComplete = () => import('@/components/common/AutoComplete.vue')
export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
    DeleteModal,
    ChangeInvoiceStatus,
    ActionsButtons,
  },

  props: ['patientCardId', 'isHistory'],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      surgeryId: null,
      surgery: {},
      dataCount: 0,
      data: [],
      EditForm: {
        surgery_id: '',
        doctor_id: '',
        amount: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        surgery_id: '',
        doctor_id: '',
        amount: '',
      },
      InvoiceId: '',
      invoiceLatestStatus: null,
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        {
          key: 'doctor.name',

          sortable: true,
          label: this.$t('common.name'),
        },
        {
          key: 'surgery.title',
          label: this.$t('surgery.surgery'),
          sortable: true,
        },
        {
          key: 'amount',
          label: this.$t('employee.amount'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('common.status'),
          sortable: true,
        },

        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    }
  },

  watch: {
    surgeryId(newSurgeryId) {
      if (newSurgeryId != null) {
        this.getSurgeryList()
      } else {
        this.EditForm.price = ''
      }
    },
  },
  mounted() {
    this.getPatientsSurgeries()
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.surgeryId = null
        this.createMode = true
        this.EditForm = {
          patient_card_id: this.patientCardId,
          surgery_id: '',
          doctor_id: '',
          amount: '',
          _method: 'POST',
        }
      } else {
        this.createMode = false
        this.EditForm.id = item.id
        this.EditForm.patient_card_id = this.patientCardId
        this.EditForm.surgery_id = item.surgery_id
        this.EditForm.doctor_id = item.doctor_id
        this.EditForm.amount = item.amount
        this.EditForm._method = 'PUT'
      }
      this.$bvModal.show('modal-surgery-insurance-edit')
    },

    showChangeStatusModal(status, id) {
      this.$bvModal.show('modal-confirm-edit-status')
      this.invoiceLatestStatus = status
      this.InvoiceId = id
    },

    badgeVariant(status) {
      switch (status) {
        case 'pending':
          return 'warning'
        case 'rejected':
          return 'danger'
        default:
          return 'success'
      }
    },
    async getSurgeryList() {
      this.loading = true
      // check if there are any null value in the obj we sending

      const url = `/surgery?filter[id]=${this.surgeryId}`

      await this.getList(url)
      this.surgery = this.all_data.data[0]

      this.loading = false
    },
    async getPatientsSurgeries() {
      this.loading = true
      // check if there are any null value in the obj we sending

      const url = `invoiceInsuranceSurgery?filter[patient_card_id]=${this.patientCardId}&page=${this.page}&take=${this.take}&sort=-id&include=doctor,surgery`

      await this.getList(url)
      this.dataCount = this.all_data.total
      this.data = this.all_data.data
      this.loading = false
    },

    deleteModel(item) {
      this.deleteForm = item
      this.$bvModal.show('modal-surgery-insurance-delete')
    },
    formatDate(date) {
      if (date) {
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/invoiceInsuranceSurgery/${this.deleteForm.id}`)
        .then(response => {
          this.getPatientsSurgeries()

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: `deleted ${this.deleteForm.first_name} successfully`,
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: `Error deleting ${this.deleteForm.first_name}`,
            },
          })
        })
    },
    submitItem() {
      for (const item in this.errorForm) {
        this.errorForm[item] = ''
        if (this.EditForm[item] == '' || this.EditForm[item] == null) delete this.EditForm[item]
      }

      this.EditForm.surgery_id = this.surgeryId

      if (this.createMode) {
        (this.params.form = this.EditForm),
        (this.params.path = '/invoiceInsuranceSurgery'),
        this.$store
          .dispatch('create', this.params)
          .then(response => {
            this.getPatientsSurgeries()
          })
          .catch(error => {
            if (
              error.response
              && error.response.status === 400
              && error.response.data
            ) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              }
            }
          })
      } else {
        (this.params.form = this.EditForm),
        (this.params.path = `/invoiceInsuranceSurgery/${this.EditForm.id}`),
        this.$store
          .dispatch('update', this.params)
          .then(response => {
            this.getPatientsSurgeries()
          })
          .catch(error => {
            if (
              error.response
              && error.response.status === 400
              && error.response.data
            ) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              }
            }
          })
      }
    },
  },
}
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}
.custom-badge {
  font-size: 0.75rem; /* Smaller font size */
  padding: 0.25rem 0.5rem; /* Smaller padding */
}

.custom-dropdown .dropdown-text {
  color: #fff; /* Ensure text is light-colored */
}

.custom-dropdown .dropdown-item-text {
  color: #212529; /* Standard text color */
  padding: 0.25rem 0.5rem; /* Adjust padding */
  cursor: pointer;
}

.custom-dropdown .dropdown-item-text:hover {
  background-color: transparent; /* No background color on hover */
}
.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
